
export function Tel({value, children}) {
    return (
        <a className="underline" href={`tel:${String(value).replace(/\D/g, '')}`}>
            {children || value}
        </a>
    );
}
